import React from 'react';
import { Shield, LogIn } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../contexts/AuthContext';

export default function LoginPage() {
  const { login } = useAuth();
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-900 to-blue-900 dark:from-gray-950 dark:to-blue-950 flex items-center justify-center p-4">
      <div className="bg-white dark:bg-gray-800 rounded-2xl shadow-2xl p-8 max-w-md w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-blue-50 dark:bg-blue-900/30 p-4 rounded-2xl">
            <Shield className="w-12 h-12 text-blue-600 dark:text-blue-400" />
          </div>
        </div>
        <h1 className="text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">{t('login.title')}</h1>
        <p className="text-gray-500 dark:text-gray-400 mb-8">
          {t('login.description')}
        </p>
        <button
          onClick={login}
          className="w-full flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white py-3 px-6 rounded-lg font-medium transition-colors"
        >
          <LogIn className="w-5 h-5" />
          {t('login.signIn')}
        </button>
        <p className="mt-6 text-xs text-gray-400 dark:text-gray-500">
          {t('login.securedBy')} &middot; SecuAAS
        </p>
      </div>
    </div>
  );
}
